import { ArrowRightOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { Alert, Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import { Auth } from 'aws-amplify';
import dayjs from 'dayjs';
import gql from 'graphql-tag';
import Cookies from 'js-cookie';
import _ from 'lodash';
import get from 'lodash/get';
import { useEffect, useState } from 'react';
import { withApollo } from 'react-apollo';
import { geolocated } from 'react-geolocated';
import PlacesAutocomplete from 'src/_shared/components/location/PlacesAutocomplete.jsx';
import { withRouter } from 'react-router-dom';
import {
	GetLoginUser,
	updateUser,
} from 'src/_shared/api/graphql/custom/users/';
import Spinner from 'src/_shared/components/spinner/SpinnerComponent.jsx';
import { RouterContext } from 'src/_shared/contexts';
import { getLocation, graphql } from 'src/_shared/services/utils.js';
import uuid from 'uuid/v4';
import { newUserkeys } from '../newUserKeys.js';
import { PageItem } from './AddLocationPageItemComponent.jsx';
import { USStates } from './copy.js';
import { ExtendedLoginLinkModal } from './extended-user-merge/index.js';
import {
	AddLocationBtn as AddLocationButton,
	CheckIcon,
	FormStyles,
	InputStyles2,
	LabelStyles,
	MiscText,
	SubTitleStyles,
	SubmitBtn as SubmitButton,
	SubmitBtnContainer as SubmitButtonContainer,
	TitleStyles,
	btnText as buttonText,
} from './newUserFormStyles.js';

const NewExtendedUserLinkForm = (props) => {
	const [form] = Form.useForm();
	const [state, setState] = useState({
		serverError: false,
		showMergeAccountModal: false,
		department: '',
		geolocationAllowed: false,
		tokenData: props.tokenData,
		loading:
			get(props, 'tokenData.identities[0].providerName', null) === 'Rush',
		redirectURL: props.redirectURL,
		submitting: false,
		currencyAbbrev: 'USD',
		contactData: {},
		multiLingualData: '',
		ml_LetsStarted: '',
		ml_FirstComplete: '',
		ml_FirstName: '',
		ml_LastName: '',
		ml_Department: '',
		ml_Location: '',
		ml_AutofillLocation: '',
		ml_Email: '',
		ml_NotValid: '',
		ml_ByCreating: '',
		ml_Terms: '',
		ml_And: '',
		ml_Privacy: '',
		ml_Agree: '',
		ml_Problem: '',
		ml_GetStarted: '',
		address: '',
	});

	const updateState = (newState) => {
		setState((prevState) => ({ ...prevState, ...newState }));
	};

	useEffect(() => {
		const initializeComponent = async () => {
			const permissions = await navigator.permissions.query({
				name: 'geolocation',
			});
			const geolocationAllowed = permissions?.state === 'granted';
			updateState({ geolocationAllowed });
			if (geolocationAllowed) getCurrentLocation();
			await getMultiLingualData();
			const { multiLingualData } = state;
			if (multiLingualData.length > 0) {
				const languageCode = 'US';
				const filteredData = multiLingualData.filter(
					(item) => item.languageCode === languageCode
				);
				const letsStarted = filteredData.find(
					(item) => item.key === newUserkeys.LetsStarted
				);
				const firstComplete = filteredData.find(
					(item) => item.key === newUserkeys.FirstComplete
				);
				const firstName = filteredData.find(
					(item) => item.key === newUserkeys.FirstName
				);
				const lastName = filteredData.find(
					(item) => item.key === newUserkeys.LastName
				);
				const department = filteredData.find(
					(item) => item.key === newUserkeys.Department
				);
				const location = filteredData.find(
					(item) => item.key === newUserkeys.Location
				);
				const autofillLocation = filteredData.find(
					(item) => item.key === newUserkeys.AutofillLocation
				);
				const email = filteredData.find(
					(item) => item.key === newUserkeys.Email
				);
				const notValid = filteredData.find(
					(item) => item.key === newUserkeys.NotValid
				);
				const byCreating = filteredData.find(
					(item) => item.key === newUserkeys.ByCreating
				);
				const terms = filteredData.find(
					(item) => item.key === newUserkeys.Terms
				);
				const and = filteredData.find((item) => item.key === newUserkeys.And);
				const privacy = filteredData.find(
					(item) => item.key === newUserkeys.Privacy
				);
				const agree = filteredData.find(
					(item) => item.key === newUserkeys.Agree
				);
				const problem = filteredData.find(
					(item) => item.key === newUserkeys.Problem
				);
				const getStarted = filteredData.find(
					(item) => item.key === newUserkeys.GetStarted
				);
				updateState({
					ml_LetsStarted: get(letsStarted, 'text', "Let's Get Started"),
					ml_FirstComplete: get(
						firstComplete,
						'text',
						'First complete your profile'
					),
					ml_FirstName: get(firstName, 'text', 'First Name'),
					ml_LastName: get(lastName, 'text', 'Last Name'),
					ml_Department: get(department, 'text', 'Department'),

					ml_Location: get(location, 'text', 'Location'),
					ml_AutofillLocation: get(
						autofillLocation,
						'text',
						'Autofill Location'
					),
					ml_Email: get(email, 'text', 'Email Address'),
					ml_NotValid: get(notValid, 'text', 'Not a valid email address.'),
					ml_ByCreating: get(
						byCreating,
						'text',
						'By creating a profile you agree to the ERIN'
					),
					ml_Terms: get(terms, 'text', 'Terms of Use'),
					ml_And: get(and, 'text', 'and'),
					ml_Privacy: get(privacy, 'text', 'Privacy Policy,'),
					ml_Agree: get(
						agree,
						'text',
						'and agree that we can send you information about jobs and referrals at your company. You can opt out at any time.'
					),
					ml_Problem: get(
						problem,
						'text',
						'There was a problem creating your account. Please try again.'
					),
					ml_GetStarted: get(getStarted, 'text', 'Get Started'),
				});
			} else {
				updateState({
					ml_LetsStarted: "Let's Get Started",
					ml_FirstComplete: 'First complete your profile',
					ml_FirstName: 'First Name',
					ml_LastName: 'Last Name',
					ml_Department: 'Department',
					ml_Location: 'Location',
					ml_AutofillLocation: 'Autofill Location',
					ml_Email: 'Email Address',
					ml_NotValid: 'Not a valid email address.',
					ml_ByCreating: 'By creating a profile you agree to the ERIN',
					ml_Terms: 'Terms of Use',
					ml_And: 'and',
					ml_Privacy: 'Privacy Policy,',
					ml_Agree:
						'and agree that we can send you information about jobs and referrals at your company. You can opt out at any time.',
					ml_Problem:
						'There was a problem creating your account. Please try again.',
					ml_GetStarted: 'Get Started',
				});
			}

			const provider = get(props, 'tokenData.identities[0].providerName', null);
			if (provider === 'Rush') {
				handleSubmit();
			}
		};

		initializeComponent();
	}, []);

	const onAuthentication = (authToken, currentUser) => {
		try {
			const host = window.location.hostname;
			if (host === 'localhost') {
				Cookies.set('jwt', authToken);
			} else {
				Cookies.set('jwt', authToken, { secure: true, httpOnly: false });
			}

			updateState({
				auth: true,
			});
		} catch (error) {
			console.log(error);
		}
	};

	const onChange = (event_) => {
		const { value } = event_.target;
		updateState({ currencyAbbrev: value });
	};

	const getCurrentLocation = () => {
		if (navigator.geolocation) {
			const options = { timeout: 60_000 };
			navigator.geolocation.getCurrentPosition(
				showLocation,
				errorHandler,
				options
			);
		} else {
			console.log('Sorry, browser does not support geolocation!');
		}
	};

	const getMultiLingualData = async () => {
		try {
			let multiLingualData = await graphql({
				input: { module: 'Registration' },
				query: 'queryMultiLingualByModuleIndex',
			});
			multiLingualData = multiLingualData?.items || multiLingualData;
			updateState({
				multiLingualData,
			});
		} catch (error) {
			console.log(error);
		}
	};

	const addLocation = async () => {
		if (props.isGeolocationAvailable) {
			const lat = props?.coords?.latitude;
			const lon = props?.coords?.longitude;
			const location = await getLocation({ lat, lon }, 'apiKey');
			updateState({ address: location?.address, location });
		} else {
			console.log('Location is not available');
		}
	};

	const errorHandler = (error) => {
		if (error.code == 1) {
			console.log('Error: Access is denied!');
		} else if (error.code == 2) {
			console.log('Error: Position is unavailable!');
		}
	};

	const handleChangeLocation = (address) => {
		updateState({ address });
	};

	const handleSelectDepartment = (department) => {
		updateState({ department });
	};

	const handleSelectLocation = async (location) => {
		updateState({ address: location?.address, location });
	};

	const handleSelectState = (state) => {
		updateState({ state });
	};

	const handleSubmit = async (values) => {
		const { onCreate, onUpdateContact, onCreateContact, setCurrentUser } =
			props;
		const user = get(props, 'user', get(props, 'userLink'));
		updateState({ serverError: false, loading: true });

		const emailAddress = values.emailAddress.toLowerCase();
		let existingContacts = await graphql({
			input: { userId: user.id, emailAddress },
			query: 'queryContactsByUserIdEmailAddressIndex',
		});
		existingContacts = existingContacts?.items || existingContacts;
		let contact = get(existingContacts, '[0]');

		try {
			// Check if there's already an extended network user with this email address
			const userEmail = get(values, 'emailAddress', '')
				.split(' ')
				.join('')
				.toLowerCase();
			const existingUser = await graphql({
				input: { emailAddress: userEmail },
				query: 'getUserByEmailAddress',
			});
			// If there is an existing user, show the modal that allows them to "merge accounts"
			if (existingUser) {
				updateState({
					emailError: true,
					loading: false,
					showMergeAccountModal: true,
				});

				return;
			}

			// If no existing user, make a new one
			const companyId =
				user.companyId ?? 'd5a17493-1e50-4a38-afa5-99623951d72e';
			await Auth.signUp({
				username: uuid(),
				password: values.password,
				attributes: {
					email: emailAddress,
				},
			}).then((authData) => {
				Auth.signIn(
					values.emailAddress.toLowerCase().trim(),
					values.password.trim()
				).then(async (authUser) => {
					contact = contact
						? contact
						: await onCreateContact({
								firstName: values.firstName,
								lastName: values.lastName,
								emailAddress,
								userId: user.id,
								companyId: user.companyId,
								inviteStatus: 'pending',
							}).then((result) => result.data.createContact);
					const extendedUserInput = {
						cognitoId: authData.user.username,
						companyId,
						emailAddress,
						extendedCompanies: JSON.stringify([user.companyId]),
						extendedContactIds: JSON.stringify([contact.id]),
						inviteStatus: 'accepted',
						role: 'extendedUser',
						firstName: values.firstName,
						lastName: values.lastName,
						departmentId: 'f5da3fd2-2ae5-41c3-8c8c-b901b7ec8eb0', // Extended Network Department
						active: true,
						createdById: user.id,
						userGroupId: '3391aa35-275b-47ee-a505-f59cbef37b42', // Extended Network Default User Group
						currency: get(state, 'currencyAbbrev', 'USD'),
					};
					if (state?.location)
						extendedUserInput.location = JSON.stringify(state.location);
					const extendedUser = await onCreate(extendedUserInput).then(
						(result) => result.data.createUser
					);
					// Update contact to accepted status, and put extended user id on the contact
					await onUpdateContact({
						id: contact.id,
						inviteStatus: 'accepted',
						extendedUserId: extendedUser.id,
					}).then(async () => {
						const { data } = await props.client.query({
							query: GetLoginUser,
							variables: {
								cognitoId: authUser.username,
								token: JSON.stringify(authUser),
							},
						});
						const currentUser = {
							...data.getLoginUser,
							authMethod: 'credentials',
							lastLogin: dayjs().toISOString(),
						};
						if (currentUser && !currentUser.active) {
							const error = new Error('User Disabled');
							error.code = 'UserDisabledException';
							throw error;
						} else {
							setCurrentUser(currentUser);
							onAuthentication(props.location.hash, currentUser);
							await props.client.mutate({
								mutation: gql(updateUser),
								variables: {
									input: {
										id: currentUser?.id,
										authMethod: 'credentials',
										lastLogin: dayjs().toISOString(),
										accessToken:
											authUser.signInUserSession.accessToken.jwtToken,
										expires: false,
									},
								},
							});
							onAuthentication(
								authUser.signInUserSession.accessToken.jwtToken,
								currentUser
							);
							window.location.href = '/dashboard';
						}
					});
				});
			});
		} catch (error) {
			console.log('Error signing up user:', error);
			updateState({
				loading: false,
				serverError: true,
			});
		}
	};

	const showLocation = async (position) => {
		const lat = position?.coords?.latitude;
		const lon = position?.coords?.longitude;
		const location = await getLocation({ lat, lon }, 'apiKey');
		updateState({ address: location?.address, location });
	};

	const renderLocation = () => {
		const { ml_Location, ml_AutofillLocation } = state;
		const { Option } = Select;
		const options = [];
		Object.keys(USStates).map((key) =>
			options.push(<Option key={key}>{USStates[key]}</Option>)
		);
		return (
			<div>
				<PageItem>
					<Col md={24} xs={48}>
						<label className={LabelStyles}>{ml_Location}</label>
						{state?.geolocationAllowed && (
							<Button className={AddLocationButton} onClick={addLocation}>
								<EnvironmentOutlined />
								<span className={buttonText}>{ml_AutofillLocation}</span>
							</Button>
						)}
					</Col>
					<Col md={24} xs={16}>
						<div>
							<PlacesAutocomplete
								address={state.address}
								auth="apiKey"
								setAddress={handleChangeLocation}
								onSelect={handleSelectLocation}
							/>
						</div>
					</Col>
				</PageItem>
			</div>
		);
	};

	const {
		contact,
		loading,
		serverError,
		showMergeAccountModal,
		submitting,
		ml_LetsStarted,
		ml_FirstComplete,
		ml_FirstName,
		ml_LastName,
		ml_Email,
		ml_NotValid,
		ml_ByCreating,
		ml_Terms,
		ml_And,
		ml_Privacy,
		ml_Agree,
		ml_Problem,
		ml_GetStarted,
	} = state;
	const theme = null;
	const whiteLabel = get(props, 'whiteLabel');

	if (submitting) {
		return (
			<div style={{ width: '100%' }}>
				<Spinner forceDefault />
			</div>
		);
	}

	return (
		<div>
			<Row className="justify-content-center">
				<h1 className={TitleStyles}>{ml_LetsStarted}</h1>
			</Row>
			<Row className="justify-content-center">
				<h2 className={SubTitleStyles}>{ml_FirstComplete}</h2>
			</Row>
			<Form
				form={form}
				className={FormStyles}
				onFinish={handleSubmit}
				onFinishFailed={(errorInfo) => {
					console.log('Failed:', errorInfo);
				}}
			>
				<Row>
					<Col md={11} xs={24}>
						<div className={InputStyles2}>
							<label className={LabelStyles}>{ml_FirstName}</label>
							<Form.Item
								name="firstName"
								rules={[
									{
										required: true,
										message: 'Please enter your first name',
									},
								]}
							>
								<Input />
							</Form.Item>
						</div>
					</Col>
					<Col md={{ span: 12, offset: 1 }} xs={24}>
						<div className={InputStyles2}>
							<label className={LabelStyles}>{ml_LastName}</label>
							<Form.Item
								name="lastName"
								rules={[
									{
										required: true,
										message: 'Please enter your last name',
									},
								]}
							>
								<Input />
							</Form.Item>
						</div>
					</Col>
				</Row>
				<Row>{renderLocation()}</Row>
				<div className={InputStyles2}>
					<label className={LabelStyles}>{ml_Email}</label>
					<Form.Item
						name="emailAddress"
						rules={[
							{
								type: 'email',
								message: ml_NotValid,
							},
						]}
					>
						<Input disabled={false} />
					</Form.Item>
				</div>
				<div className={InputStyles2}>
					<label className={LabelStyles}>Create Password</label>
					<Form.Item
						name="password"
						rules={[
							{
								required: true,
								message: 'Password Required',
							},
							{ min: 8 },
						]}
					>
						<Input.Password className={InputStyles2} autoComplete="on" />
					</Form.Item>
				</div>

				{!whiteLabel && (
					<p className={MiscText}>
						{ml_ByCreating}{' '}
						<a
							href="http://erinapp.com/terms-of-use"
							rel="noopener noreferrer"
							target="_blank"
						>
							{ml_Terms}
						</a>{' '}
						{ml_And}{' '}
						<a
							href="https://erinapp.com/privacy-policy"
							rel="noopener noreferrer"
							target="_blank"
						>
							{ml_Privacy}
						</a>{' '}
						{ml_Agree}
					</p>
				)}
				{serverError ? <Alert type="error" message={ml_Problem} /> : null}

				<Form.Item className={SubmitButtonContainer(theme)}>
					<Button className={SubmitButton(theme)} htmlType="submit">
						{ml_GetStarted}
						<ArrowRightOutlined className={CheckIcon} />
					</Button>
				</Form.Item>
			</Form>
			<Modal
				cancelButtonProps={{ style: { display: 'none' } }}
				open={loading}
				footer={null}
				closable={false}
				width="100%"
				bodyStyle={{
					backgroundColor: '#242e3f',
					height: window.innerHeight,
				}}
				style={{
					top: '0px',
				}}
			>
				<div
					style={{
						marginTop: '10%',
					}}
				>
					<Spinner forceDefault />
				</div>
			</Modal>
			<RouterContext.Consumer>
				{({ onAuthentication }) => (
					<ExtendedLoginLinkModal
						contact={contact}
						visible={showMergeAccountModal}
						closeModal={() => updateState({ showMergeAccountModal: false })}
						client={props.client}
						onAuthentication={onAuthentication}
						onUpdateContact={props.onUpdateContact}
					/>
				)}
			</RouterContext.Consumer>
		</div>
	);
};

export default withApollo(
	withRouter(
		geolocated({
			positionOptions: {
				enableHighAccuracy: true,
			},
			userDecisionTimeout: 60_000,
		})(NewExtendedUserLinkForm)
	)
);
